import { render } from "./SuccessTips.vue?vue&type=template&id=50901a62&scoped=true"
import script from "./SuccessTips.vue?vue&type=script&lang=js"
export * from "./SuccessTips.vue?vue&type=script&lang=js"

import "./SuccessTips.vue?vue&type=style&index=0&id=50901a62&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Mahmoud\\Desktop\\Bugs\\Dubai Projects\\JC_2\\mongo-web\\website\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50901a62"]])

export default __exports__